<template>
  <div class="crypto-select-frame">
    <!-- Custom selector -->
    <div class="lang-select">
      <button
        class="btn-select"
        @click="toggleDropdown"
      >
        <li v-if="selectedValue">
          <img
            :src="selectedValue.typeImage"

            class="w-6 h-6"
          >
          <span>{{ selectedValue.typeName }}</span>
        </li>
      </button>

      <!-- Dropdown -->
      <div :class="['b', { active: isOpen }]">
        <ul class="crypto-list">
          <li
            v-for="type in filteredTypes"
            :key="type.payment_id"
            @click="selectCrypto(type)"
          >
            <img
              :src="type.typeImage"
            >
            <span>{{ type.typeName }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CryptoSelector',

  props: {
    filteredTypes: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      default: () => null
    }
  },

  data() {
    return {
      isOpen: false,
      selectedValue: this.value
    }
  },

  watch: {
    value(newValue) {
      this.selectedValue = newValue
    },

    selectedValue(newValue) {
      this.$emit('input', newValue)
      this.$emit('change', newValue)
    }
  },

  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },

    selectCrypto(type) {
      this.selectedValue = type
      this.isOpen = false
    }

    // getCryptoImage(typeName) {
    //   // Add null check
    //   if (!typeName) return ''

    //   try {
    //     // First get the first part before any hyphen or space
    //     const symbol = typeName.split(/[\s-]/)[0].trim().toLowerCase()
    //     // Try to load the image
    //     return require(`@/assets/${this.$store.getters.currentTheme}/images/crypto-${symbol}.svg`)
    //   } catch (error) {
    //     // Return a fallback image if the crypto image isn't found
    //     return require(`@/assets/${this.$store.getters.currentTheme}/images/crypto-usdt.svg`)
    //   }
    // }
  }
}
</script>

